import { render, staticRenderFns } from "./JzzIndex.vue?vue&type=template&id=2a38e276&scoped=true"
import script from "./JzzIndex.vue?vue&type=script&lang=js"
export * from "./JzzIndex.vue?vue&type=script&lang=js"
import style0 from "./JzzIndex.vue?vue&type=style&index=0&id=2a38e276&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a38e276",
  null
  
)

export default component.exports